var map = {
	"./en_US3.png": "XS6g",
	"./mobile/en_US3.png": "rnAk",
	"./mobile/zh_CN3.png": "3sdA",
	"./mobile/zh_HANT3.png": "nIDr",
	"./zh_CN3.png": "Bnek",
	"./zh_HANT3.png": "7WkA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hZh0";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*3\.png$
// module id = hZh0
// module chunks = 1